<template>
    <div class="form-group">
        <label :for="id">{{label}}</label><br>
        <textarea
                :name="name"
                :id="id"
                v-on:input="$emit('input', $event.target.value)"
                cols="30" rows="10"
        >{{value}}</textarea>
    </div>

</template>

<script>
  import { randomString } from '../../utils/string'

  export default {
    name: 'text-area-input',
    props: {
      name: {
        type: String,
        required: true
      },
      id: {
        type: String,
        default: () => {
          return randomString()
        }
      },
      required: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      value: ''
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/form/TextAreaInput.vue